import React from 'react';
import styled from '@emotion/native';
import { useQuery } from '@apollo/client';
import useIsDesktop from '@/shared/hooks/useIsDesktop';
import { IsDesktopProps } from '@/shared/styles/types';
import ScrollableView from '@/shared/components/ScrollableView';
import { mint } from '@/shared/styles/colors';
import { GET_STYLIST_SCHEDULING_DATA } from '@/shared/queries/stylistSchema';
import { QueryResult } from '@/shared/types/generated';
import AvailabilityManager from '@/shared/components/schedule/AvailabilityManager';
import { ActivityIndicator } from 'react-native-paper';
import { green } from '@/shared/styles/colors';

const Availability = () => {
  const isDesktop = useIsDesktop();
  const {
    data: { schedulingData } = {},
    loading,
    refetch: refetchSchedulingData,
  } = useQuery<QueryResult<'schedulingData'>>(GET_STYLIST_SCHEDULING_DATA, {
    fetchPolicy: 'cache-first',
  });

  if (loading) {
    return (
      <ScrollableView
        scrollEnabled
        contentContainerStyle={{
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
        }}
      >
        <ActivityIndicator size="large" color={green} />
      </ScrollableView>
    );
  }

  return (
    <ScrollableView
      scrollEnabled
      contentContainerStyle={{
        alignItems: 'center',
        height: '100%',
      }}
    >
      <Container isDesktop={isDesktop}>
        <AvailabilityManager
          schedulingData={schedulingData}
          schedulingDataLoading={loading}
          onRefetchSchedulingData={refetchSchedulingData}
        />
      </Container>
    </ScrollableView>
  );
};

const Container = styled.View<IsDesktopProps>(({ isDesktop }) => ({
  flexGrow: 1,
  backgroundColor: mint,
  marginHorizontal: isDesktop ? 48 : 0,
  paddingTop: isDesktop ? 34 : 24,
  paddingBottom: isDesktop ? 40 : 28,
  marginTop: isDesktop ? 14 : 0,
  marginBottom: isDesktop ? 34 : 0,
  alignSelf: 'stretch',
  alignItems: 'center',
  borderRadius: isDesktop ? 8 : 0,
}));

export default Availability;
